<template>
    <kt-panel>
        <kt-panel-body>
            <form @submit.prevent="submit" id="gateway_form">
                <kt-row>
                    <kt-col lg="4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="farsi_name">
                                {{ $t('label.farsi_name') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="farsi_name"
                                    name="farsi_name"
                                    v-model="form_data.farsi_name"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="psp">
                                {{ $t('label.psp') }}
                            </kt-form-label>
                            <kt-form-select size="4" id="psp" name="psp" v-model="form_data.psp">
                                <option
                                        v-bind:key="index"
                                        v-for="(psp, index) in psp_list"
                                        v-bind:value="psp.value"
                                        :selected="psp.value"
                                >
                                    {{ psp.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="4" md="6" sm="12">
                        <kt-form-group>
                            <kt-form-label for="status">
                                {{ $t('label.status') }}
                            </kt-form-label>
                            <kt-form-select size="4" id="status" name="status" v-model="form_data.status">
                                <option
                                        v-bind:key="index"
                                        v-for="(status, index) in statuses"
                                        v-bind:value="status.value"
                                        :selected="status.value"
                                >
                                    {{ status.name }}
                                </option>
                            </kt-form-select>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
                <novin
                        v-if="form_data.psp == 'novin'"
                        :form_data="form_data"
                        :port_config="port_config"
                ></novin>
                <parsian
                        v-if="form_data.psp == 'parsian'"
                        :form_data="form_data"
                        :port_config="port_config"
                ></parsian>
                <pasargad
                        v-if="form_data.psp == 'pasargad'"
                        :form_data="form_data"
                        :port_config="port_config"
                ></pasargad>
                <saman
                        v-if="form_data.psp == 'saman'"
                        :form_data="form_data"
                        :port_config="port_config"
                ></saman>
                <kt-form-action class="mt-4">
                    <button
                            class="btn btn-md btn-success btn-wide"
                            type="submit"
                            id="submit_btn"
                    >
                        {{ $t('btn.submit') }}
                    </button>
                </kt-form-action>
            </form>
        </kt-panel-body>
    </kt-panel>
</template>

<script>

import { i18n } from '@/plugins/i18n'
import { dedicatedStatusStr, dedicatedStatus } from '@/constants/dedicatedStatus'
import { novin, parsian, pasargad, saman } from './psp_data_forms'

export default {
    props: {
        submit: {
            default: () => {
                return {}
            },
            type: Function
        },
        form_data: {
            default() {
                return {}
            },
            type: Object
        },
        port_config: {
            default() {
                return {}
            },
            type: Object
        }
    },
    data () {
        return {
            collective: {},
            psp_list: [
                {
                    name: i18n.t('psp_list.novin'),
                    value: 'novin'
                },
                {
                    name: i18n.t('psp_list.pasargad'),
                    value: 'pasargad'
                },
                {
                    name: i18n.t('psp_list.parsian'),
                    value: 'parsian'
                },
                {
                    name: i18n.t('psp_list.saman'),
                    value: 'saman'
                },
            ],
            statuses: [
                {
                    name: dedicatedStatusStr.ACTIVE,
                    value: dedicatedStatus.ACTIVE
                },
                {
                    name: dedicatedStatusStr.PENDING,
                    value: dedicatedStatus.PENDING
                },
                {
                    name: dedicatedStatusStr.REJECTED,
                    value: dedicatedStatus.REJECTED
                },
                {
                    name: dedicatedStatusStr.BLOCKED,
                    value: dedicatedStatus.BLOCKED
                },
                {
                    name: dedicatedStatusStr.SEND_TO_PSP,
                    value: dedicatedStatus.SEND_TO_PSP
                },
                {
                    name: dedicatedStatusStr.REJECTED_BY_PSP,
                    value: dedicatedStatus.REJECTED_BY_PSP
                },
            ],
        }
    },
    components:{
        'novin': novin,
        'parsian': parsian,
        'pasargad': pasargad,
        'saman': saman,
    },
}
</script>

<style>
    .color-novin{
        color: #683f84;
    }
    .color-mellat{
        color: #ed1b2f;
    }
    .color-saman{
        color: #07abea;
    }
    .color-parsian{
        color: #9c0f1e;
    }
    .color-pasargad{
        color: #f58500;
    }
</style>